import { UnstyledButton, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconDots } from '@tabler/icons-react';
import { translate } from '@/lib';
import { useStore } from '@/store';
import clsx from 'clsx';
import style from './BottomNav.module.scss';
import { isNavItemActive, type NavItem } from './bottomNavTypes';

type BottomNavMoreProps = {
  items: NavItem[];
  currentPath: string;
  onNavigate: (path: string) => void;
};

export function BottomNavMore({ items, currentPath, onNavigate }: BottomNavMoreProps) {
  const isIngameBrowser = useStore((s) => s.isIngameBrowser);
  const [opened, { toggle, close }] = useDisclosure(false);

  const isOverflowActive = items.some((item) => isNavItemActive(item.path, currentPath));

  const handleItemClick = (path: string) => {
    onNavigate(path);
    close();
  };

  return (
    <div className={style.moreWrapper}>
      <UnstyledButton
        onClick={toggle}
        className={clsx(style.navItem, { [style.active]: isOverflowActive })}
      >
        <div className={style.navIcon}>
          <IconDots size={24} />
        </div>
        <Text size="xs" className={style.navLabel}>
          {translate('ff.nav.more', 'More')}
        </Text>
      </UnstyledButton>

      {opened && (
        <>
          <div className={style.backdrop} onClick={close} />
          <div
            className={clsx(
              style.moreFlyout,
              isIngameBrowser ? style.moreFlyoutHorizontal : style.moreFlyoutVertical
            )}
          >
            {items.map((item) => (
              <UnstyledButton
                key={item.path}
                onClick={() => handleItemClick(item.path)}
                className={clsx(style.navItem, {
                  [style.active]: isNavItemActive(item.path, currentPath),
                })}
                style={{
                  width: 'auto'
                }}
              >
                <div className={style.navIcon}>{item.icon}</div>
                <Text size="xs" className={style.navLabel}>
                  {translate(item.translationKey, item.label)}
                </Text>
              </UnstyledButton>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default BottomNavMore;
